var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
        },
      ],
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: this.selectScene,
              expression: "this.selectScene",
            },
          ],
          staticClass: "scene-menu-container",
        },
        [
          _c(
            "el-menu",
            {
              staticClass: "el-menu-demo",
              attrs: { mode: "horizontal", "default-active": _vm.selectScene },
              on: { select: _vm.handleSceneSelect },
            },
            [
              _vm.selectedScenes.indexOf("1") !== -1
                ? _c("el-menu-item", { attrs: { index: "1" } }, [
                    _c("i", { staticClass: "el-icon-food" }),
                    _vm._v("\n        堂食\n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedScenes.indexOf("2") !== -1
                ? _c("el-menu-item", { attrs: { index: "2" } }, [
                    _c("i", { staticClass: "el-icon-shopping-bag-2" }),
                    _vm._v("\n        自提\n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedScenes.indexOf("3") !== -1
                ? _c("el-menu-item", { attrs: { index: "3" } }, [
                    _c("i", { staticClass: "el-icon-truck" }),
                    _vm._v("\n        外卖\n      "),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "scene-actions" },
            [
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-folder-add" },
                  on: {
                    click: function ($event) {
                      return _vm.handleBatchChangeStatus(1)
                    },
                  },
                },
                [_vm._v("\n        批量上架\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: { type: "warning", icon: "el-icon-folder-remove" },
                  on: {
                    click: function ($event) {
                      return _vm.handleBatchChangeStatus(0)
                    },
                  },
                },
                [_vm._v("\n        批量下架\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "tac" },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-menu",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectScene,
                      expression: "selectScene",
                    },
                  ],
                  staticClass: "el-menu-vertical-demo",
                  attrs: { "default-openeds": ["100"] },
                  on: { select: _vm.handleGroupSelect },
                },
                [
                  _c(
                    "el-submenu",
                    { attrs: { index: "100" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c(
                          "span",
                          { on: { click: _vm.handleGroupSelectAll } },
                          [_vm._v("全部")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-menu-item-group",
                        _vm._l(_vm.dishGroups, function (item) {
                          return _c(
                            "el-menu-item",
                            { key: item.id, attrs: { index: "" + item.id } },
                            [_vm._v(_vm._s(item.templateGroupName))]
                          )
                        }),
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 20 } },
            _vm._l(_vm.templateGroupItems, function (detail) {
              return _c(
                "span",
                { staticClass: "group-block" },
                [
                  _c("div", { staticClass: "group-header" }, [
                    _c("div", { staticClass: "group-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(detail.templateGroupName) +
                          "|" +
                          _vm._s(detail.templateGroupNameEn) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "group-time" }, [
                      _vm._v(
                        "\n            生效时间:" +
                          _vm._s(detail.beginTimeStr) +
                          " - " +
                          _vm._s(detail.endTimeStr) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "group-time" }, [
                      _vm._v("\n            生效星期:\n            "),
                      detail.checkedWeekdays &&
                      detail.checkedWeekdays.indexOf(1) !== -1
                        ? _c("span", [_vm._v("周一")])
                        : _vm._e(),
                      _vm._v(" "),
                      detail.checkedWeekdays &&
                      detail.checkedWeekdays.indexOf(2) !== -1
                        ? _c("span", [_vm._v("周二")])
                        : _vm._e(),
                      _vm._v(" "),
                      detail.checkedWeekdays &&
                      detail.checkedWeekdays.indexOf(3) !== -1
                        ? _c("span", [_vm._v("周三")])
                        : _vm._e(),
                      _vm._v(" "),
                      detail.checkedWeekdays &&
                      detail.checkedWeekdays.indexOf(4) !== -1
                        ? _c("span", [_vm._v("周四")])
                        : _vm._e(),
                      _vm._v(" "),
                      detail.checkedWeekdays &&
                      detail.checkedWeekdays.indexOf(5) !== -1
                        ? _c("span", [_vm._v("周五")])
                        : _vm._e(),
                      _vm._v(" "),
                      detail.checkedWeekdays &&
                      detail.checkedWeekdays.indexOf(6) !== -1
                        ? _c("span", [_vm._v("周六")])
                        : _vm._e(),
                      _vm._v(" "),
                      detail.checkedWeekdays &&
                      detail.checkedWeekdays.indexOf(7) !== -1
                        ? _c("span", [_vm._v("周日")])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "group-actions" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      key: detail.id,
                      ref: "table_" + detail.id,
                      refInFor: true,
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: detail.items,
                        stripe: "",
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                      },
                      on: {
                        "sort-change": function ($event) {
                          return _vm.handleTableSortChange($event, detail)
                        },
                        "selection-change": function (selection) {
                          return _vm.handleSelectionChange(selection, detail)
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "55" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "明细id",
                          prop: "id",
                          align: "center",
                          width: "100",
                          sortable: "custom",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "商品名称",
                          prop: "goodsName",
                          align: "center",
                          "min-width": "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "商品编码",
                          prop: "goodsCode",
                          align: "center",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "菜品价格",
                          align: "center",
                          width: "120",
                          prop: "price",
                          sortable: "custom",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    "\n              ￥" +
                                      _vm._s(row.marketPrice) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "商品图",
                          align: "center",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  row.goodsThumbnailUrl === null ||
                                  row.goodsThumbnailUrl === "" ||
                                  row.goodsThumbnailUrl === undefined
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                未上传图片\n              "
                                        ),
                                      ])
                                    : _c("el-image", {
                                        staticStyle: {
                                          width: "80px",
                                          height: "40px",
                                        },
                                        attrs: {
                                          src:
                                            _vm.resPath + row.goodsThumbnailUrl,
                                          fit: "contain",
                                          "preview-src-list": [
                                            _vm.resPath + row.goodsThumbnailUrl,
                                          ],
                                          "preview-teleported": "",
                                        },
                                      }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "状态",
                          prop: "status",
                          align: "center",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-color": "#13ce66",
                                      "inactive-color": "#ff4949",
                                      "active-value": 1,
                                      "inactive-value": 0,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handleStatusChange(
                                          $event,
                                          row
                                        )
                                      },
                                    },
                                    model: {
                                      value: row.status,
                                      callback: function ($$v) {
                                        _vm.$set(row, "status", $$v)
                                      },
                                      expression: "row.status",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "门店库存",
                          align: "center",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  row.inventoryFlag == 1
                                    ? _c("i", { staticClass: "el-icon-check" })
                                    : _c("i", { staticClass: "el-icon-close" }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("tableFrom.Operation"),
                          align: "center",
                          width: "250",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            icon: "el-icon-edit",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleEdit(row.id)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  编辑\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加分组",
            visible: _vm.groupAddVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.groupAddVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-container",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c("el-input", {
                staticClass: "filter-item",
                staticStyle: { width: "200px" },
                attrs: { placeholder: "分组名称", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleGroupAddFilter($event)
                  },
                },
                model: {
                  value: _vm.groupAddQuery.keywords,
                  callback: function ($$v) {
                    _vm.$set(_vm.groupAddQuery, "keywords", $$v)
                  },
                  expression: "groupAddQuery.keywords",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleGroupAddFilter },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              key: "222",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.groupAddData,
                stripe: "",
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  prop: "id",
                  align: "center",
                  width: "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "分组名称（中）",
                  prop: "name",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "分组名称（英）",
                  prop: "nameEn",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "分组icon", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.iconUrl === null ||
                        row.iconUrl === "" ||
                        row.iconUrl === undefined
                          ? _c("span", [
                              _vm._v("\n            未上传图片\n          "),
                            ])
                          : _c("el-image", {
                              staticStyle: { width: "80px", height: "40px" },
                              attrs: {
                                src: _vm.resPath + row.iconUrl,
                                fit: "contain",
                                "preview-src-list": [_vm.resPath + row.iconUrl],
                                "preview-teleported": "",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "生效星期",
                  prop: "name",
                  align: "center",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(1) !== -1
                          ? _c("span", [_vm._v("周一")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(2) !== -1
                          ? _c("span", [_vm._v("周二")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(3) !== -1
                          ? _c("span", [_vm._v("周三")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(4) !== -1
                          ? _c("span", [_vm._v("周四")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(5) !== -1
                          ? _c("span", [_vm._v("周五")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(6) !== -1
                          ? _c("span", [_vm._v("周六")])
                          : _vm._e(),
                        _vm._v(" "),
                        row.checkedWeekdays &&
                        row.checkedWeekdays.indexOf(7) !== -1
                          ? _c("span", [_vm._v("周日")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "生效时间",
                  prop: "name",
                  align: "center",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n           " +
                            _vm._s(row.beginTimeStr) +
                            "-" +
                            _vm._s(row.endTimeStr) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: _vm.$t("tableFrom.Operation"),
                  align: "center",
                  width: "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: row.checked,
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-plus",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addGroup(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n              添加\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加商品",
            visible: _vm.itemAddVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.itemAddVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-container",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c("el-input", {
                staticClass: "filter-item",
                staticStyle: { width: "200px" },
                attrs: { placeholder: "菜品id/名称", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleItemAddFilter($event)
                  },
                },
                model: {
                  value: _vm.itemAddQuery.keywords,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemAddQuery, "keywords", $$v)
                  },
                  expression: "itemAddQuery.keywords",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleItemAddFilter },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              key: "333",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.itemAddData,
                stripe: "",
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  prop: "goodsName",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "商品编码",
                  prop: "goodsCode",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "所属大类",
                  prop: "categoryFirstName",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "所属小类",
                  prop: "categorySecondName",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品图", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.goodsThumbnailUrl === null ||
                        row.goodsThumbnailUrl === "" ||
                        row.goodsThumbnailUrl === undefined
                          ? _c("span", [
                              _vm._v("\n            未上传图片\n          "),
                            ])
                          : _c("el-image", {
                              staticStyle: { width: "80px", height: "40px" },
                              attrs: {
                                src: _vm.resPath + row.goodsThumbnailUrl,
                                fit: "contain",
                                "preview-src-list": [
                                  _vm.resPath + row.goodsThumbnailUrl,
                                ],
                                "preview-teleported": "",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: _vm.$t("tableFrom.Operation"),
                  align: "center",
                  width: "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: row.checked,
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-plus",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addGoods(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n              添加\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemAddTotal > 0
            ? _c("sw-page", {
                key: "4",
                staticStyle: { display: "block", float: "none" },
                attrs: {
                  listQuery: _vm.itemAddQuery,
                  total: _vm.itemAddTotal,
                  pos: "btmRight",
                },
                on: { retPage: _vm.retPage },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "商品编辑",
            visible: _vm.editVisible,
            size: "600px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editFormRef",
              staticClass: "dialog-form",
              staticStyle: { padding: "15px" },
              attrs: { model: _vm.editForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模板名称", prop: "goodsName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editForm.goodsName,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "goodsName", $$v)
                      },
                      expression: "editForm.goodsName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店市场价", prop: "marketPrice" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { type: "number", autosize: "" },
                    model: {
                      value: _vm.editForm.marketPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "marketPrice", $$v)
                      },
                      expression: "editForm.marketPrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店促销价", prop: "promotePrice" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { type: "number", autosize: "" },
                    model: {
                      value: _vm.editForm.promotePrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "promotePrice", $$v)
                      },
                      expression: "editForm.promotePrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店会员价", prop: "vipPrice" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { type: "number", autosize: "" },
                    model: {
                      value: _vm.editForm.vipPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "vipPrice", $$v)
                      },
                      expression: "editForm.vipPrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "菜品简介", prop: "goodsBrief" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 4, maxRow: 6 },
                    },
                    model: {
                      value: _vm.editForm.goodsBrief,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "goodsBrief", $$v)
                      },
                      expression: "editForm.goodsBrief",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "详细描述", prop: "goodsDesc" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 4, maxRow: 6 },
                    },
                    model: {
                      value: _vm.editForm.goodsDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "goodsDesc", $$v)
                      },
                      expression: "editForm.goodsDesc",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "自动同步", prop: "autoSyncFlag" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-text": "开启",
                      "inactive-text": "关闭",
                      "active-value": 1,
                      "inactive-value": 0,
                    },
                    model: {
                      value: _vm.editForm.autoSyncFlag,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "autoSyncFlag", $$v)
                      },
                      expression: "editForm.autoSyncFlag",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveEntity()
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }